import React from "react";
import { CATEGORIES } from "../mock";

// On-brand generated cover used when a book has no real uploaded artwork.
// Guarantees the cover always matches the title/author.
const PALETTES = [
  ["#0F2E2B", "#061715"],
  ["#123833", "#08201C"],
  ["#0D2A30", "#05161A"],
  ["#16332A", "#091A14"],
  ["#1A2F38", "#0A181D"],
  ["#0E2B24", "#051610"],
  ["#213330", "#0C1A18"],
  ["#0B262E", "#041318"],
];

function hashIndex(str, mod) {
  let h = 0;
  for (let i = 0; i < (str || "").length; i++) h = (h * 31 + str.charCodeAt(i)) >>> 0;
  return h % mod;
}

export default function BookCover({ book, className = "", showBrand = true }) {
  const hasReal = book?.coverPath && book?.cover;
  if (hasReal) {
    return <img src={book.cover} alt={book.title_en} loading="lazy" className={`object-cover ${className}`} />;
  }

  const [c1, c2] = PALETTES[hashIndex(book?.id || book?.title_en || "x", PALETTES.length)];
  const title = book?.title_en || "Untitled";
  const cat = CATEGORIES.find((c) => c.id === book?.category)?.en || "";
  const titleSize = title.length > 26 ? "text-lg" : title.length > 16 ? "text-xl" : "text-2xl";

  return (
    <div
      className={`relative flex flex-col justify-between p-4 overflow-hidden ${className}`}
      style={{ background: `linear-gradient(155deg, ${c1} 0%, ${c2} 100%)` }}
    >
      {/* decorative glow */}
      <div
        className="absolute -right-8 -top-10 w-32 h-32 rounded-full blur-2xl opacity-30"
        style={{ background: "radial-gradient(circle, #3FBFA8 0%, transparent 70%)" }}
      />
      <div className="relative flex items-center justify-between">
        {showBrand && (
          <span className="text-[9px] font-semibold tracking-[0.2em] text-brand-300/80 uppercase">Trellure</span>
        )}
        <span className="w-6 h-[2px] bg-brand-400/70 rounded-full" />
      </div>

      <div className="relative">
        <h3 className={`font-display font-semibold leading-tight text-brand-50 ${titleSize}`}>{title}</h3>
        <div className="mt-2 w-8 h-[3px] rounded-full bg-brand-400" />
        <p className="mt-2 text-[11px] text-brand-100/70 line-clamp-1">{book?.author}</p>
      </div>

      <div className="relative flex items-end justify-between">
        <span className="text-[9px] uppercase tracking-wider text-brand-100/50 line-clamp-1 max-w-[70%]">{cat}</span>
        {book?.narrator && (
          <span className="text-[8px] text-brand-100/40 italic line-clamp-1 text-right max-w-[40%]">{book.narrator}</span>
        )}
      </div>
    </div>
  );
}
